import { useCallback, useContext } from "react";
import { match } from "ts-pattern";
import Button, { EButtonVariant } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";

import classes from "./classes.module.scss";
import { ETab, TabContext } from "components/pages/ProfessionalSpace/tabs/Casting/contexts/Tab";

type IButtonTabProps = {
	tab: ETab;
};

export default function Tabs() {
	return (
		<div className={classes["root"]}>
			<ButtonTab tab={ETab.FORUM} />
			<ButtonTab tab={ETab.VOTE} />
			<ButtonTab tab={ETab.CASTING} />
		</div>
	);
}

function ButtonTab(props: IButtonTabProps) {
	const { isActiveTab, setActiveTab, isTabEnabled } = useContext(TabContext);

	const getTabTitle = useCallback((tab: ETab) => {
		return match(tab)
			.with(ETab.FORUM, () => I18n.asset.pages.professional_space.tabs.casting.tabs.forum)
			.with(ETab.VOTE, () => I18n.asset.pages.professional_space.tabs.casting.tabs.vote)
			.with(ETab.CASTING, () => I18n.asset.pages.professional_space.tabs.casting.tabs.casting)
			.exhaustive();
	}, []);

	return (
		<Button variant={EButtonVariant.SELECTOR} onClick={() => setActiveTab(props.tab)} isSelected={isActiveTab(props.tab)} disabled={!isTabEnabled(props.tab)}>
			<Typography type="p" size="medium" weight="bold">
				{getTabTitle(props.tab)}
			</Typography>
		</Button>
	);
}
